import React from "react";

export function MedicalKnowledgeIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M20.3992 3.6002V20.4002H3.59922V3.6002H20.3992ZM21.7192 1.2002H2.27922C1.67922 1.2002 1.19922 1.6802 1.19922 2.2802V21.7202C1.19922 22.2002 1.67922 22.8002 2.27922 22.8002H21.7192C22.1992 22.8002 22.7992 22.2002 22.7992 21.7202V2.2802C22.7992 1.6802 22.1992 1.2002 21.7192 1.2002ZM10.7992 6.0002H17.9992V8.4002H10.7992V6.0002ZM10.7992 10.8002H17.9992V13.2002H10.7992V10.8002ZM10.7992 15.6002H17.9992V18.0002H10.7992V15.6002ZM5.99922 6.0002H8.39922V8.4002H5.99922V6.0002ZM5.99922 10.8002H8.39922V13.2002H5.99922V10.8002ZM5.99922 15.6002H8.39922V18.0002H5.99922V15.6002Z" fill="none"/>
        </svg>
    );
}
